module.exports = __webpack_public_path__ + "img/CA220.3b42aae3.png";